import { render } from "./CountDown.vue?vue&type=template&id=1dd327f5"
import script from "./CountDown.vue?vue&type=script&lang=ts"
export * from "./CountDown.vue?vue&type=script&lang=ts"
script.render = render

export default script